import {
    CreditCard,
    Error,
    Facebook,
    Google,
    Instagram,
    Inventory,
    LocalAtm,
    LocalShippingOutlined,
    People,
    Pinterest,
    Public,
    SettingsBackupRestore,
    Store,
    Storefront,
    StoreOutlined,
    type SvgIconComponent,
    ThumbUpAltOutlined,
    Timer,
    Web
} from "@mui/icons-material";
import { ImageIcon } from "../../components";
import type {
    OrderStatus,
    OrderType,
    PaymentType,
    SalesChannel,
    ValuesOf,
} from "../../models/enums";

export const statusIconMap: Map<ValuesOf<typeof OrderStatus>, SvgIconComponent> = new Map<
    ValuesOf<typeof OrderStatus>,
    SvgIconComponent
>([
    ["Pending", Timer],
    ["Canceled", Error],
    ["Complete", ThumbUpAltOutlined],
    ["Prepared", Inventory],
    ["Shipped", LocalShippingOutlined],
    ["Temporary", Timer],
]);
export const statusColorMap: Map<ValuesOf<typeof OrderStatus>, string> = new Map<ValuesOf<typeof OrderStatus>, string>([
    ["Pending", "#e8b946"],
    ["Canceled", "#ff5d42"],
    ["Complete", "#5dbaa1"],
    ["Shipped", "#679ad4"],
    ["Prepared", "#a571d4"],
    ["Temporary", "#bdbdbd"],
]);
export const typeIconMap: Map<ValuesOf<typeof OrderType>, SvgIconComponent> = new Map<ValuesOf<typeof OrderType>, SvgIconComponent>([
    ["Shipping", LocalShippingOutlined],
    ["InStore", StoreOutlined],
    ["Refund", SettingsBackupRestore],
    ["External", SettingsBackupRestore],
]);

export const channelIconMap: Map<ValuesOf<typeof SalesChannel>, SvgIconComponent> = new Map<ValuesOf<typeof SalesChannel>, SvgIconComponent>([
    ["POS", Store],
    ["Partner", People],
    ["Website", Web],
    ["Instagram", Instagram],
    ["Facebook", Facebook],
    ["Google", Google],
    ["Pinterest", Pinterest],
    ["Amazon", Storefront],
    ["eBay", Storefront],
    ["TikTok", Public]
]);

export const paymentIconMap: Map<ValuesOf<typeof PaymentType>, SvgIconComponent> = new Map<ValuesOf<typeof PaymentType>, SvgIconComponent>([
    ["Cash", LocalAtm],
    ["Card", CreditCard],
]);

export const OrderStatusIcon = (props: {
    status: ValuesOf<typeof OrderStatus>;
}): JSX.Element => (
    <ImageIcon
        {...props}
        color={statusColorMap.get(props.status)}
        Fallback={statusIconMap.get(props.status)!}
    />
);

export const OrderTypeIcon = (props: {
    type: ValuesOf<typeof OrderType>;
}): JSX.Element => (
    <ImageIcon {...props} color="primary" Fallback={typeIconMap.get(props.type)!} />
);

export const SalesChannelIcon = (props: {
    source: ValuesOf<typeof SalesChannel>;
}): JSX.Element => (
    <ImageIcon {...props} color="primary" Fallback={channelIconMap.get(props.source)!} />
);
